import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { isEmail, sendNotification } from "../../utils";
import BunkeyAPI from "../../api/BunkeyAPI";
import {
  newInvitation,
  userExistsByEmail,
  userExistsReset
} from "../../actions/UsersAction";
import moment from "moment";
import {
  Modal,
  Button,
  Select,
  Spin,
  Icon
} from "antd";
import CloseIcon from "../../assets/fi_x-circle.svg";
import "./new-invitation.css";

const { Option } = Select;

const antIcon = <Icon type="loading" style={{ fontSize: 14 }} spin />

export class NewInvitation extends Component {

  constructor(props) {
    super(props)

    this.state = {
      email: '',
      options: [],
      group: [],
      isDisabledToAction: true,
      isActionAlive: false
    }
  }

  componentDidMount() {
    const { group } = this.props;
    this.setState({
      options: (group || []).map((r, k) => (
        <Option key={k} value={r.name} uid={r._id}>
          {r.name}
        </Option>
      ))
    });
  }

  componentDidUpdate(prevProps) {
    const { group } = this.props;
    if (prevProps.group !== group) {
      this.setState({
        options: (group || []).map((r, k) => (
          <Option key={k} value={r.name} uid={r._id}>
            {r.name}
          </Option>
        ))
      });
    }
  }

  handleEmailExists = e => {
    const { intl, workclient } = this.props;

    if (isEmail(e.target.value)) {
      if (e.target.value.endsWith('@bunkey.tv')) {
        this.setState({ isDisabledToAction: true });
      } else {
        BunkeyAPI({
          url: `users/validate`,
          method: "POST",
          data: {
            email: e.target.value
          }
        }).then(res => {
          if (res.status === 200) {
            if (res.data.code && res.data.code === "UserNotFound") {
              this.setState({ isDisabledToAction: false });
            } else if (res.data.workClients && res.data.workClients.length > 0) {
              if (res.data.workClients.includes(workclient)) {
                this.setState({
                  isDisabledToAction: true
                }, () => sendNotification(
                  "error",
                  intl,
                  intl.formatMessage({ id: "existing_associated_mail" })
                ));
              } else {
                this.setState({ isDisabledToAction: false });
              }
            } else {
              this.setState({ isDisabledToAction: false });
            }
          }
        }).catch(err => {
          console.log('err', err);
        })
      }
    } else {
      this.setState({ isDisabledToAction: true });
    }
  };

  handleOnChangeGroup = (item, list) => {
    this.setState({ group: list.map(r => r.props.uid) });
  };

  handleInputOnChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  callbackInvitation = () => {
    const { handleHiddenAddModalUser, intl } = this.props
    sendNotification(
      "success",
      intl,
      intl.formatMessage({ id: "invitation_sended_success" })
    );
    this.setState({
      email: '',
      options: [],
      group: [],
      isDisabledToAction: true,
      isActionAlive: false
    }, handleHiddenAddModalUser())
  }

  sendInvitation = () => {
    const { email, group, isActionAlive } = this.state;
    const { workclient } = this.props

    if (isActionAlive) return

    if (email === '') {
      sendNotification('error', this.props.intl, this.props.intl.formatMessage({ id: 'empty_email_input' }))
      return
    }

    if (group.length === 0) {
      sendNotification('error', this.props.intl, this.props.intl.formatMessage({ id: 'must_select_group' }))
      return
    }

    this.setState({ isActionAlive: true }, this.props.newInvitation(
      email,
      "operator",
      workclient,
      group,
      "Infinite",
      moment().format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD"),
      "",
      this.callbackInvitation
    ));
  }

  render() {

    const { showAddModalUser, handleHiddenAddModalUser, intl } = this.props
    const { email, options, isDisabledToAction, isActionAlive } = this.state

    return (
      <Modal
        visible={showAddModalUser}
        onCancel={handleHiddenAddModalUser}
        footer={null}
        className="modal-parent modal-pay"
        scrollableBody={true}
        closeIcon={<img src={CloseIcon} alt={"icon close"} />}
        destroyOnClose>
        <div id='img-new-invitation'>
          <div style={{ width: '65%', padding: 30 }}>
            <h3>{intl.formatMessage({ id: "invite_user" })}</h3>
            <input
              className="form-control"
              name="email"
              type="text"
              value={email}
              placeholder={intl.formatMessage({ id: "email" })}
              onBlur={this.handleEmailExists}
              onChange={this.handleInputOnChange}
            />
            <div style={{ marginTop: 20 }}>
              <h5>{intl.formatMessage({ id: "user_email_invitation" })}</h5>
            </div>
            <div style={{ marginTop: 20 }}>
              <h5>{intl.formatMessage({ id: "groups" })}</h5>
              <Select
                defaultActiveFirstOption
                mode="multiple"
                placeholder={intl.formatMessage({ id: "select" })}
                onChange={this.handleOnChangeGroup}
                style={{ width: "100%" }}
              >
                {options}
              </Select>
            </div>

            <div style={{ marginTop: 20 }}>
              <Button
                style={{ marginLeft: "auto", padding: "0 30px" }}
                disabled={isDisabledToAction}
                type={"primary"}
                onClick={() => this.sendInvitation()}
              >
                {isActionAlive ? <Spin indicator={antIcon} /> : intl.formatMessage({ id: "invite_user" })}
              </Button>
            </div>

          </div>
        </div>

      </Modal>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    data: state.users.data,
    invitationSent: state.users.invitationSent,
    group: state.group.byClientData,
    workclient: state.client.workclient,
  }
}

const mapDispatchToProps = {
  userExistsByEmail,
  userExistsReset,
  newInvitation,
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(NewInvitation)))